import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private readonly _statusLoader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private readonly _msgLoader: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(undefined);

  private requestsAtivas = 0; // contador de requisições ativas

  showLoader(mensagem?: string): void {
    this.requestsAtivas++;
    this.putMsgLoader(mensagem);
    if (this.requestsAtivas === 1) {
      this._statusLoader.next(true);
    }
  }

  hideLoader(): void {
    if (this.requestsAtivas > 0) {
      this.requestsAtivas--;
    }
    if (this.requestsAtivas === 0) {
      this.putMsgLoader();
      this._statusLoader.next(false);
    }
  }

  get statusLoader(): boolean {
    return this._statusLoader.value;
  }

  putMsgLoader(mensagem?: string): void {
    this._msgLoader.next(mensagem);
  }

  get msgLoader(): string | undefined {
    return this._msgLoader.value;
  }

}
